import {API_URLS} from '@px/const/urls';
import {http} from '@px/helper/http';

export const contractApi = {
  tpslModeUpdate(params) {
    return http.post(API_URLS.CONTRACTBIZ_TPSLMODE_UPDATE, {params});
  },
  tradeDataPositionStats(query) {
    return http.get(API_URLS.TRADE_DATA_POSITION_STATS, {query});
  },
  tradeDataFundingFeeStats(query) {
    return http.get(API_URLS.TRADE_DATA_FUNDING_FEE_STATS, {query});
  },
};
